import React from 'react';
import whitelogo from './DEEPECHO_logo_white.png';
import largeLogo from './DEEPECHO logo.png';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useMe } from './helpers/api/users/users';
import { useLogout } from './helpers/api/auth/auth';

const DefaultLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const logoutMutation = useLogout();
  const hideHeaderRoutes = [
    '/login',
    '/forgot-password',
    '/reset-password',
    '/set-up-account',
    '/force-password-change',
  ];
  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);
  const { data: user } = useMe({ retry: 0, enabled: !shouldHideHeader });

  const handleLogout = async () => {
    try {
      await logoutMutation.mutateAsync({});
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="flex min-h-screen">
      <div className="w-full">
        <div className="absolute inset-0 bg-card-color-200" />
        <div className="relative z-10 flex h-full items-center justify-center">
          <div className="w-full">{children}</div>
        </div>
      </div>

      {!shouldHideHeader && (
        <div className="fixed top-0 left-0 right-0 z-20 flex items-center justify-between bg-transparent p-4">
          <div className="mr-6">
            <img className="hidden dark:block" src={whitelogo} />
            <img className="dark:hidden" src={largeLogo} />
          </div>

          <div className="flex items-center space-x-8">
            {!user ? (
              <Link to="/login" className="text-base-content">
                SignIn
              </Link>
            ) : (
              <>
                <Link to="/home" className="text-base-content">
                  Workspace
                </Link>
                <a
                  onClick={handleLogout}
                  className="text-base-content cursor-pointer rounded-md border py-1 px-2 transition duration-150 ease-in-out hover:bg-black hover:text-white"
                >
                  Logout
                </a>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DefaultLayout;
